import React, { useEffect, useState } from "react";

import { getList, GetRecords, URLPRIFIX, UpdateRecord } from "../../functions/api";
import {
  getFulllocal,
  getlocal,
  getStorage,
  setlocal,
} from "../../functions/localstorage";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { RiAdminLine } from "react-icons/ri";
import { MdContentPasteSearch } from "react-icons/md";
import { MdOutlineDashboard } from "react-icons/md";
import { SiPhpmyadmin } from "react-icons/si";
import { useStore } from "../../Components/StateProvider";
import LoadingSpinner from "../../Components/Elements/LoadingSpinner";
import { GiHamburgerMenu } from "react-icons/gi";
import { contentHeader } from "../../Constancs/cssconst";
import { FaChevronRight, FaChevronDown, FaChartBar } from "react-icons/fa";
import "../../Components/Layout/sider.css";
import { useLocation, useParams } from "react-router-dom";
import { URL_Account_Company_List } from "../../Constancs/apiconst";
import { FaMoneyBillTransfer } from "react-icons/fa6";
import { TbHexagonLetterM } from "react-icons/tb";
import { LuBarChartHorizontalBig } from "react-icons/lu";
import { IoSettingsOutline } from "react-icons/io5";
import { handleNotificationNavigation } from "../../services/notificationNavigationHelper";

const AccountsLayout = ({ children, HeaderTitle }) => {
  const { companyId } = useParams();
  const store = useStore();
  const user = getlocal("system")?.user || {};
  const [sider, setsider] = useState("max-sm:hidden");
  const props = getlocal("properties");
  // console.log("props", props);

  let category = {};

  let menus = {
    Dashboard: {
      "meta-data": { icon: <MdOutlineDashboard />, parent: true },
      link: `/${URLPRIFIX}/${companyId}/accounts/dashboard`,
      disabled: !props?.accountsdashboard?.on_off,
    },
    Configuration: {
      disabled: !props?.configurations?.on_off,
      "meta-data": { icon: <IoSettingsOutline />, parent: true },
      child: {
        "– Transaction Sequence": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/invoice-no-generation`,
          disabled: !props?.configurations?.on_off,
        },
      },
    },
    Master: {
      disabled: !(
        props?.AccountGroups?.on_off ||
        props?.ChartsOfAccounts?.on_off ||
        props?.budget?.on_off ||
        props?.customer?.on_off ||
        props?.vendors?.on_off
      ),
      "meta-data": { icon: <TbHexagonLetterM />, parent: true },
      child: {
        "– Account Groups": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/group`,
          disabled: !props?.AccountGroups?.on_off,
        },
        "– Chart of Accounts": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/ledger`,
          disabled: !props?.ChartsOfAccounts?.on_off,
        },
        "– Budget": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/budgetlist`,
          disabled: !props?.budget?.on_off,
        },
        "– Customer": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/customer`,
          disabled: !props?.customer?.on_off,
        },
        "– Vendor": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/vendor`,
          disabled: !props?.vendors?.on_off,
        },
      },
    },
    Transactions: {
      disabled: !(
        (props?.invoices?.on_off ||
          props?.receipts?.on_off ||
          props?.Expenses?.on_off ||
          props?.payables?.on_off ||
          props?.journals?.on_off) &&
        [1, 4].includes(user.role)
      ),
      "meta-data": { icon: <FaMoneyBillTransfer />, parent: true },
      child: {
        "– Invoices": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/invoice`,
          disabled: !props?.invoices?.on_off,
        },
        "– Receipts": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/receipt`,
          disabled: !props?.receipts?.on_off,
        },
        "– Expenses": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/expense`,
          disabled: !props?.Expenses?.on_off,
        },
        "– Payables": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/payable`,
          disabled: !props?.payables?.on_off,
        },

        "– Journals": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/journal`,
          disabled: !props?.journals?.on_off,
        },
      },
    },
    Reimbursement: {
      "meta-data": { icon: <FaMoneyBillTransfer />, parent: true },
      link: `/${URLPRIFIX}/${companyId}/accounts/expense`,
      disabled: !(props?.Expenses?.on_off && ![1, 4].includes(user.role)),
    },
    Reports: {
      disabled: !(
        props?.daybook?.on_off ||
        props?.trialbalance?.on_off ||
        props?.customerledger?.on_off ||
        props?.balancesheet?.on_off ||
        props?.profitandloss?.on_off ||
        props?.budgetactual?.on_off ||
        props?.reconciliation?.on_off ||
        props?.statement_of_accounts?.on_off ||
        props?.tdsReport?.on_off
      ),
      "meta-data": { icon: <FaChartBar />, parent: true },
      child: {
        // "Journals List": {
        //   "meta-data": { parent: false },
        //   link: `/${URLPRIFIX}/${companyId}/accounts/journal`,
        //   // disabled: !props?.users?.view,
        // },
        "– Day Book": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/daybook`,
          disabled: !props?.daybook?.on_off,
        },
        "– Trail Balance": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/trailbalance`,
          disabled: !props?.trialbalance?.on_off,
        },
        "– Customer Ledger": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/customerledger`,
          disabled: !props?.customerledger?.on_off,
        },
        "– Balance Sheet": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/balancesheet`,
          disabled: !props?.balancesheet?.on_off,
        },
        "– Profit & Loss": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/profitloss`,
          disabled: !props?.profitandloss?.on_off,
        },
        "– Budget-vs-Actual": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/budget-vs-actual`,
          disabled: !props?.budgetactual?.on_off,
        },
        "– Reconciliation ": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/reconciliation`,
          disabled: !props?.reconciliation?.on_off,
        },

        "– Statement of Accounts ": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/statements_of_accounts`,
          disabled: !props?.statement_of_accounts?.on_off,
        },
        "– TDS Report": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/tdsreport`,
          disabled: !props?.tdsReport?.on_off,
        },
        "– Billing Report": {
          "meta-data": { parent: false },
          link: `/${URLPRIFIX}/${companyId}/accounts/billingreport`,
          disabled: !props?.billingreport?.on_off,
        },
      },
    },
  };

  useEffect(() => {
    getList({
      listUrl: "/clientcategory/getClientCategorylist",
      field: "",
      sort: "asc",
      page: 1,
      count: 100,
    }).then((res) => {
      console.log("Responces of category");
      if (res.success) {
        res?.data?.list?.map((item) => {
          category[item.categoryName] = {
            "meta-data": { icon: "", parent: false },
            link: "/" + URLPRIFIX + "/nonlitigation/" + item.categoryName,
          };
        });
      }
    });
  }, [companyId]);

  return (
    <>
      <main className=" h-screen max-sm:h-svh bg-secondary text-primary font-times grid grid-rows-12 relative">
        <div className=" row-span-1 max-sm:row-span-1 ">
          <Header Header={HeaderTitle} store={store} setsider={setsider} />
        </div>
        <div className="grid grid-cols-8 row-span-11 max-sm:row-span-11">
          <div
            className={
              "col-span-1 h-full bg-primary rounded-tr-[20px] Scrollleft " +
              sider
            }
          >
            <div className="innerscroll bg-primary text-secondary h-full max-sm:rounded-none max-sm:absolute max-sm:right-0 max-sm:w-[270pxx] max-sm:z-50">
              <Sider menus={menus} setsider={setsider} />
            </div>
          </div>
          <div className="col-span-7 max-sm:col-span-10 overflow-x-auto px-[0.5%] py-[0.5%] relative ">
            {store.getsystemvalue("loading") && (
              <LoadingSpinner Message={"Loading"} />
            )}
            {children}{" "}
          </div>
        </div>
      </main>
    </>
  );
};

const Header = ({ Header = "", store, setsider }) => {
  const user = getlocal("system")?.user || {};
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const { companyId } = useParams();

  const [isPopupVisible, setPopupVisible] = useState({
    notification: false,
    profile: false,
  });
  const [Company, setCompany] = useState([]);
  const [changecompany, setchangecompany] = useState(false);
  const [ActiveCompany, setActiveCompany] = useState("");
  const notifications = store.getsystemvalue("Notification") || [];
  const unreadNotificationCount = store.getsystemvalue("UnreadNotificationCount") || 0;
  useEffect(() => {
    setActiveCompany(companyId);
    getNotification();
    LoadCompany();
  }, [companyId]);
  useEffect(() => {
    console.log("ActiveCompany", ActiveCompany, queryParams, companyId);
  }, [ActiveCompany]);

  function getNotification() {
    getList({
      listUrl: "/api/notifications/byuserid/" + user.id,
    }).then((res) => {
      console.log("notification", res);
      store.setsystemvalue("Notification", res?.data || []);
    });

    getList({
      listUrl: "/api/notifications/unreadcount/" + user.id,
    }).then((res) => {
      store.setsystemvalue("UnreadNotificationCount", res?.data?.unreadCount || 0);
    });
  }

  const handleNotificationClick = async (notification) => {
    if (notification?.id && !notification?.isRead) {
      await UpdateRecord(`/api/notifications/${notification.id}/read`);
      store.setsystemvalue(
        "Notification",
        notifications.map((item) =>
          item.id === notification.id ? { ...item, isRead: true } : item
        )
      );
      store.setsystemvalue(
        "UnreadNotificationCount",
        Math.max(unreadNotificationCount - 1, 0)
      );
    }

    handleNotificationNavigation(
      notification,
      (url) => {
        store.navTo(url);
        togglePopup("notification");
      },
      URLPRIFIX
    );
  };
  const togglePopup = (field) => {
    let newfield = {};
    if (field === "notification") {
      newfield = {
        notification: !isPopupVisible.notification,
        profile: false,
      };
    } else {
      newfield = {
        notification: false,
        profile: !isPopupVisible.profile,
      };
    }
    setPopupVisible((prev) => {
      prev = newfield;
      return { ...prev };
    });
  };

  function LoadCompany() {
    GetRecords(URL_Account_Company_List).then((res) => {
      if (res.success) {
        res = res?.record?.list || [];
        setCompany(res);
      }
    });
  }

  return (
    <div
      className="grid grid-cols-8 h-full shadow-sm shadow-primary"
      key={companyId}
    >
      {changecompany && <LoadingSpinner Message={"Switching Company"} />}
      <div className=" col-span-1 ">
        <div
          className="flex justify-center items-center h-full px-[6%] gap-2 cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            store.navTo(
              "/" + URLPRIFIX + "/" + companyId + "/accounts/dashboard"
            );
          }}
        >
          <img
            src="/Assets/images/Logo.png"
            alt="Logo"
            className="max-sm:w-[92px] max-sm:h-[67px] md:w-[42px] md:h-[30px] lg:w-[40px] lg:h-[30px] "
          />
        </div>
      </div>
      <div className=" col-span-4">
        <div className="flex items-center h-full pl-[2%]  font-semibold max-sm:text-[38px] md:text-[24px] lg:text-[24px]">
          {Header}
        </div>
      </div>
      <div className="col-span-3">
        <div className="flex items-center justify-end px-5 h-full gap-4 max-sm:hidden relative">
          {[1, 4].includes(user.role) && (
            <div className={"mb-2 p-1 pt-3 z-50 h-full"}>
              <select
                className="w-full h-full hover:bg-tertiary hover:bg-opacity-45"
                value={ActiveCompany}
                onChange={(event) => {
                  let local = getFulllocal();
                  local.system.user = {
                    ...local?.system?.user,
                    company: event?.target?.value,
                  };

                  setlocal(local);
                  window.location.replace(
                    "/" +
                    URLPRIFIX +
                    "/" +
                    event.target.value +
                    "/accounts/dashboard"
                  );
                }}
              >
                {Company.map((company, index) => (
                  <option value={company.id}>{company.company_name}</option>
                ))}
              </select>
            </div>
          )}
          <div // company div
            className={
              "absolute top-full right-6 mt-0 bg-secondary min-w-[220px] max-h-[350px] p-4 shadow-2xl rounded-2xl border border-[#a9a9ff] border-1 transition-all ease-in-out " +
              (isPopupVisible.profile
                ? " z-10 opacity-100 delay-75 translate-y-0 scale-100 duration-100 translate-x-0"
                : " -Z-10 opacity-0 -translate-y-24 translate-x-10 scale-50 duration-500")
            }
          >
            <div>
              <h1 className={contentHeader}>{user.name?.toUpperCase()}</h1>
              <h1 className={"text-[12px]"}>profile</h1>
            </div>
            <button
              className={
                "absolute right-5 top-4 text-[18px] bg-primary lg:h-6 lg:w-6 h-9 w-9 flex justify-center items-center rounded-full  text-secondary hover:bg-tertiary hover:bg-opacity-45" +
                (isPopupVisible.profile
                  ? " cursor-pointer "
                  : " cursor-default ")
              }
              onClick={() => isPopupVisible.profile && togglePopup("profile")}
            >
              &times;
            </button>
            <div className="overflow-y-auto max-h-[250px]">
              {store?.state?.properties?.users?.view && (
                <div
                  className={
                    "mb-2 p-1 pt-3 border-b border-gray-300 hover:bg-tertiary hover:bg-opacity-45 relative " +
                    (isPopupVisible.profile
                      ? " cursor-pointer "
                      : " cursor-default ")
                  }
                >
                  <h1
                    onClick={() => {
                      store.navTo(
                        "/" + URLPRIFIX + "/users/profile/" + user.id
                      );
                      isPopupVisible.profile && togglePopup("profile");
                    }}
                  >
                    My Profile
                  </h1>
                </div>
              )}

              <div
                className={
                  "mb-2 p-1 pt-3 border-b border-gray-300 hover:bg-tertiary hover:bg-opacity-45 relative " +
                  (isPopupVisible.profile
                    ? " cursor-pointer "
                    : " cursor-default ")
                }
              >
                <h1
                  onClick={() => {
                    store.logout();
                  }}
                >
                  Logout
                </h1>
              </div>
            </div>
          </div>
          <button
            className="relative z-50"
            onClick={(e) => {
              e.preventDefault();
              togglePopup("notification");
              getNotification();
              console.log("On click detected ");
            }}
          >
            <img
              src="/Assets/images/notification.png"
              alt="Notification"
              id="notification"
              className="max-sm:w-[92px] max-sm:h-[67px] md:w-[25px] md:h-[25px] lg:w-[30px] lg:h-[30px] cursor-pointer hover:scale-110 hover:animate-pulse hover:duration-150 "
            />
            {unreadNotificationCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] min-w-[18px] h-[18px] px-1 rounded-full flex items-center justify-center">
                {unreadNotificationCount > 99 ? "99+" : unreadNotificationCount}
              </span>
            )}
          </button>

          <div //notification div
            className={
              "absolute top-full right-6 mt-0 bg-secondary min-w-[320px] max-h-[350px] p-4 shadow-2xl rounded-2xl border border-[#a9a9ff] border-1 transition-all ease-in-out " +
              (isPopupVisible.notification
                ? " z-10 opacity-100 delay-75 translate-y-0 scale-100 duration-100"
                : " -Z-10 opacity-0 -translate-y-32 translate-x-4 scale-50 duration-500")
            }
          >
            <h1 className={contentHeader}>Notifications</h1>

            <button
              className={
                "absolute right-5 top-4 text-[18px] bg-primary lg:h-6 lg:w-6 h-9 w-9 flex justify-center items-center rounded-full  text-secondary hover:bg-tertiary hover:bg-opacity-45" +
                (isPopupVisible.notification
                  ? " cursor-pointer "
                  : " cursor-default ")
              }
              onClick={() =>
                isPopupVisible.notification && togglePopup("notification")
              }
            >
              &times;
            </button>

            {notifications.length > 0 ? (
              <div className="overflow-y-auto max-h-[250px]">
                {notifications.map((item, index) => (
                  <div
                    key={item.id || index}
                    onClick={() => handleNotificationClick(item)}
                    className={
                      "mb-2 p-3 pt-5 border-b border-gray-300 hover:bg-tertiary hover:bg-opacity-45 relative cursor-pointer rounded-lg " +
                      (!item.isRead ? "bg-white bg-opacity-90" : "bg-transparent opacity-80")
                    }
                  >
                    <h4 className="text-sm font-bold">{item.title}</h4>
                    <p className="text-sm my-3">{item.message || item.body}</p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-gray-600 text-sm">You have no notifications</p>
            )}
          </div>

          <img // company Icon
            src="/Assets/images/profile.png"
            alt="Logo"
            onClick={() => {
              togglePopup("profile");
              !isPopupVisible.profile && LoadCompany();
            }}
            className="max-sm:w-[92px] max-sm:h-[67px] md:w-[25px] md:h-[25px] lg:w-[30px] lg:h-[30px] cursor-pointer z-50 hover:scale-110"
          />
          <div
            className={
              "mb-2 p-1 pt-3 hover:bg-red hover:bg-opacity-45 relative z-50 cursor-pointer "
            }
          >

            <h1
              onClick={() => {
                if ([1].includes(user.role)) {
                  store.navTo("/" + URLPRIFIX + "/accounts");
                } else {
                  store.navTo("/" + URLPRIFIX + "/dashboard");
                }
              }}
            >
              Exit
            </h1>



          </div>


        </div>

        <div className="items-center justify-center h-full md:gap-6 lg:gap-8 max-sm:flex hidden">
          <div
            className="text-[38px]"
            onClick={(e) => {
              e.preventDefault();
              setsider((prev) => {
                if (prev === "max-sm:hidden") {
                  prev = "max-sm:block";
                } else {
                  prev = "max-sm:hidden";
                }
                return prev;
              });
            }}
          >
            <GiHamburgerMenu />
          </div>
        </div>
      </div>
    </div>
  );
};

const Sider = ({ menus, setsider }) => {
  const store = useStore();
  const [sidemenu, setsidemenu] = useState(menus);

  function open(menu, open) {
    // setsidemenu(!sidemenu);

    menu = menu.replace("`", "");
    let position = "";
    menu.split("`").map((item) => (position += "['" + item + "'].child"));
    position = position.substring(0, position.length - 6);

    position =
      "sidemenu" +
      position +
      "['meta-data'].open = !sidemenu" +
      position +
      "['meta-data'].open";

    eval(position);
    // console.log("menus", sidemenu);
    setsidemenu((prev) => {
      prev = sidemenu;
      return { ...prev };
    });
  }

  return (
    <div className="flex flex-col gap-1 pl-[5%] py-[8%]">
      <Menus obj={sidemenu} open={open} parent={""} setsider={setsider} />
    </div>
  );
};

function Menus({ obj, parent, open, setsider }) {
  return Object.keys(obj).map((head, index) => {
    // console.log("new log", obj[head], obj[head]["meta-data"].icon);
    if (!obj[head].disabled) {
      return (
        <Menu
          key={index}
          heading={head}
          icon={obj[head]["meta-data"].icon}
          parent={obj[head]["meta-data"].parent}
          onClick={() => {
            open(parent + "`" + head, obj[head]["meta-data"].open);
          }}
          open={obj[head]["meta-data"].open}
          link={obj[head].link}
          button={obj[head].button}
          setsider={setsider}
        >
          {" "}
          {obj[head].child && (
            <Menus
              obj={obj[head].child}
              open={open}
              parent={parent + "`" + head}
              setsider={setsider}
            />
          )}
        </Menu>
      );
    }
  });
}

function Menu({
  heading,
  icon,
  parent,
  children,
  onClick,
  open,
  link,
  button,
  setsider,
}) {
  const store = useStore();
  return (
    <>
      <div
        className={
          parent
            ? "flex items-center justify-start mb-[2%] gap-1 cursor-pointer "
            : "flex items-center justify-start my-[5%] gap-2 cursor-pointer hover:bg-[#3c3c6a]"
        }
        onClick={(e) => {
          e.preventDefault();
          if (!link && !button) {
            onClick();
          }
          if (link && !button) {
            // store.reset({});
            store.navTo(link);
            setsider("max-sm:hidden");
          }
          if (button !== undefined && link === undefined) {
            switch (button.toLowerCase()) {
              case "logout":
                store.logout();
                setsider("max-sm:hidden");
                break;

              default:
                break;
            }
          }
        }}
      >
        <div className="text-[24px]">{icon}</div>
        <div className="flex items-center gap-3">
          <h1
            className={
              parent
                ? // ? "max-sm:text-[30px] md:text-[14px] lg:text-[18px] "
                "max-sm:text-[26px] md:text-[9px] lg:text-[14px] "
                : "max-sm:text-[26px] md:text-[9px] lg:text-[14px] "
            }
          >
            {heading}
          </h1>
          {!link && !button && (open ? <FaChevronDown /> : <FaChevronRight />)}
        </div>
      </div>
      {parent && <hr className="w-[80%]" />}
      <div className=" md:ml-[12PX] lg:ml-[15PX] border-l-[1px] border-secondary">
        {open && children}
      </div>
    </>
  );
}

export default AccountsLayout;
